export default {"src":"/_next/static/media/invoice-bg.7fd2c223.svg","height":405,"width":439,"blurWidth":0,"blurHeight":0};